export default "__VITE_ASSET__CQJIlNy$__"